import PropTypes from 'prop-types';
import { memo } from 'react';
import * as MapSearchUtils from './MapSearchUtils.js';


export const MapEssentialsCard = memo(function({essential}) {
    const topItem = essential.topItem;
    const teacherId = essential.teacherId;
    const productImage = topItem.imageUrl;
    const itemName = topItem.name;
    const topItemPrice = MapSearchUtils.Helpers.roundCostToCompleteForDisplay(essential.topItem.price > 25 ? 10 : essential.topItem.price).toLocaleString('en-US');
    const teacherName = essential.teacherName;

    return (
        <div key={`essential_${essential.teacherId}`}>
            <a target='_blank' className='essentials-list-card mini' href={essential.essentialsListUrl}>
                <form className='form-redux' method='get' id={`essentialsListUpsellForm-${teacherId}`}
                      name='essentialsListUpsellForm'
                      action={secureBaseURL + 'donors/givingCart.html'}>
                    <input type='hidden' value={teacherId} name='essentialsListTeacherId'/>
                    <input type='hidden' value={true} name='gift'/>
                    <input type='hidden' value={topItemPrice} name='amount'/>
                    <div className='list-details'>
                        <div>
                            <div className='description'>{teacherName} needs {itemName}, and other essentials</div>
                            <button className='button-primary small essentials'>
                                <span className='name'>Add to cart</span>
                                <span className='price'>${topItemPrice}</span>
                            </button>
                        </div>
                        <div className='top-supply' style={{ backgroundImage: 'url(' + productImage + ')' }}></div>
                    </div>
                </form>
            </a>
        </div>
    );
});

MapEssentialsCard.propTypes = {
    essential: PropTypes.object.isRequired
};
